import { gql } from "graphql-tag";

export const DELETE_ORDER = gql`
	mutation DeleteOrder($id: Int!) {
		delete_order(id: $id)
	}
`;

export const UPDATE_ORDER_STATUS = gql`
	mutation UpdateOrderStatus($id: Int, $order_status_id: Int) {
		update_order_status(id: $id, order_status_id: $order_status_id)
	}
`;

export const UPDATE_ORDER_PRODUCT = gql`
	mutation UpdateOrderProduct($order_id: Int!, $product_id: Int!, $quantity: Int!) {
		update_order_product(order_id: $order_id, product_id: $product_id, quantity: $quantity)
	}
`;

export const DELETE_ORDER_PRODUCT = gql`
	mutation DeleteOrderProduct($order_id: Int!, $product_id: Int!) {
		delete_order_product(order_id: $order_id, product_id: $product_id)
	}
`;

export const ADD_ORDER_PRODUCT = gql`
	mutation AddOrderProduct($order_id: Int!, $product_id: Int!, $quantity: Int!) {
		add_order_product(order_id: $order_id, product_id: $product_id, quantity: $quantity)
	}
`;

export default { DELETE_ORDER, UPDATE_ORDER_STATUS, UPDATE_ORDER_PRODUCT, DELETE_ORDER_PRODUCT, ADD_ORDER_PRODUCT };
